import React, { Fragment } from 'react';
import fr from 'facet-rest';
import AccountsHeading from 'Components/Blueprint/UI/Accounts/Heading';
import AccountsTable from 'Components/Blueprint/UI/Accounts/Table';
import AccountsTableInner from 'Components/Blueprint/UI/Accounts/TableInner';
import ShadowBox from 'Components/UI/ShadowBox';
import EditButton from 'Components/Blueprint/UI/EditButton';
import { fullDate } from 'Consts/DateFormats';
import { addSpacesAndCapitalize } from 'Helpers/Formats';
import BlueprintBalanceForResources from 'Components/Blueprint/UI/BlueprintBalanceForResources';
import Currency from 'Components/Format/Currency';
import Content from 'Components/Blueprint/UI/Content';
import PropTypes from 'prop-types';
import moment from 'moment';
import { openURLInNewTab } from 'Helpers/Navigation';

const View = ({ liabilities }) => {
  return (
    <div className="liabilities">
      {liabilities.length > 0 ? (
        <Fragment>
          <AccountsHeading
            title="Debts"
          >
            <AccountsTable className="accounts-debts">
              <tr className="headings">
                <td className="h-type">Type</td>
                <td className="h-institution">Institution</td>
                <td className="h-balance">Balance</td>
                <td className="h-loan-type">Loan Type</td>
                <td className="h-rate">Rate</td>
                <td className="h-monthly-payment">Minimum Monthly Payment</td>
                <td className="h-maturity">Maturity</td>
              </tr>
            </AccountsTable>
          </AccountsHeading>
          {/*
          |--------------------------------------------------------------------------
          | Liabilities
          |--------------------------------------------------------------------------
          */}
          {liabilities.length > 0 && (
            <Fragment>
              <AccountsTableInner>
                <ShadowBox>
                  <AccountsTable className="accounts-debts">
                    {liabilities.map(account => (
                      <tr key={`${account.id()}l`} className="data">
                        <td className="edit">
                          <EditButton
                            title="Edit Debt Account"
                            onClick={() => {
                              account.withRelationship(
                                fr.relationships.edit.name,
                                (rel) => openURLInNewTab(rel.link('related').url()),
                                () => null,
                              );
                            }}
                          />
                        </td>
                        <td className="type">
                          {account.attr('type') && addSpacesAndCapitalize(account.attr('type'))}
                        </td>
                        <td className="institution">
                          {account.attr('institution') ? account.attr('institution') : ''}
                        </td>
                        <BlueprintBalanceForResources account={account} />
                        <td className="loan-type">
                          {account.attr('loanType') ? addSpacesAndCapitalize(account.attr('loanType')) : ''}
                        </td>
                        <td className="rate">
                          {`${account.attr('interestRate') ? account.attr('interestRate') : '0.00'}%`}
                        </td>
                        <td className="monthly-payment">
                          {account.attr('minimumMonthlyPayment') !== null && (
                            <Currency
                              amount={account.attr('minimumMonthlyPayment')}
                            />
                          )}
                        </td>
                        <td className="maturity">
                          {account.attr('maturityDate') ? moment(account.attr('maturityDate')).utc().format(fullDate) : ''}
                        </td>
                      </tr>
                    ))}
                  </AccountsTable>
                </ShadowBox>
              </AccountsTableInner>
            </Fragment>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <AccountsHeading title="Debts" />
          <Content className="double-side-padding no-top-padding">
            <p>No debts.</p>
          </Content>
        </Fragment>
      )}
    </div>
  );
};

View.propTypes = {
  liabilities: PropTypes.array,
};
View.defaultProps = {
  liabilities: [],
};

export default View;
